
import Vue from "vue";
export default Vue.extend({
	props: {
		value: {
			type: Number,
			required: true
		}
	},
	computed: {
		tabs():string[]{
			return [
				this.$ct("columns"),
				this.$ct("style"),
				this.$ct("filters"),
				this.$ct("conditions")
			].map(t=>t.toString());
		}
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
